import { VisitorHeaderDataProviderProps } from '@care/navigation';
import {
  GroupItemKinds,
  GroupKind,
} from '@care/navigation/dist/components/GlobalNavIA/NavLinkList/NavLinkList';
import {
  seoNavigationLinkSection_seoNavigationLinkSection_SEONavigationLinkSectionSuccess_seoNavigationLinkSection as SEONavigationLinkSection,
  seoNavigationLinkSection_seoNavigationLinkSection_SEONavigationLinkSectionSuccess_seoNavigationLinkSection_childCareLinks as SEONavigationLink,
} from '@/__generated__/seoNavigationLinkSection';
import { getStartedCommonLinks } from './getStartedCommonLinks';
import { buildVgnLinkList } from './buildVgnLinkList';

/**
 * Generates the "Find Jobs" menu links based on the provided base URL and navigation link section.
 *
 * @param {string} baseURL - The base URL for the application.
 * @param {SEONavigationLinkSection} navigationLinkSection - The section containing SEO navigation links.
 * @returns {VisitorHeaderDataProviderProps['findJobsMenuLinks']} - The structured find jobs menu links.
 */

export const getFindJobsMenuContent = (
  baseURL: string,
  navigationLinkSection: SEONavigationLinkSection
): VisitorHeaderDataProviderProps['findJobsMenuLinks'] => {
  const findJobsContent: GroupKind[] = [
    {
      id: 'get-started',
      kind: 'group',
      items: getStartedCommonLinks(baseURL),
    },
  ];

  Object.entries(navigationLinkSection)
    // filter for jobsLinks only
    .filter(([key]: [string, SEONavigationLink[]]) => key === 'jobsLinks')
    .forEach(([, value]: [string, SEONavigationLink[]]) => {
      const vgnLinkList = buildVgnLinkList(baseURL, 'jobsLinks', value, false);

      const exploreJobsLabel: GroupItemKinds = {
        kind: 'label',
        value: 'Explore jobs',
        id: 'explore-jobs',
      };

      findJobsContent.push({
        id: 'jobs-group',
        kind: 'group',
        items: [exploreJobsLabel, ...vgnLinkList],
      });
    });

  return {
    id: 'find-jobs',
    title: 'Find jobs',
    items: findJobsContent,
  };
};
